import { Button, Box, Paper, Typography } from "@mui/material";
import { Translate as TranslateIcon, CheckCircle, Cancel } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import "./style.css";

function TranslationCreator({ textTranslation, onWholeTextTranslation, originalText }) {
    const [isEditing, setIsEditing] = useState(false);
    const [currentTranslation, setCurrentTranslation] = useState('');

    const handleTranslationInput = (e) => {
        if (e.target.name === "wholeText") {
            setCurrentTranslation(e.target.value);
        }
    };

    useEffect(() => {
        if (textTranslation) {
            setCurrentTranslation(textTranslation);
        }
    }, [textTranslation]);

    const getButtonIndicator = () => {
        if (!textTranslation) return '✗';
        if (textTranslation.trim() === '') return '✗';
        return '✓';
    };

    return ( 
        <Box>
            { !isEditing && 
                <Button 
                    variant="contained" 
                    startIcon={<TranslateIcon />}
                    onClick={() => setIsEditing(true)}
                    endIcon={
                        <span style={{
                            color: textTranslation && textTranslation.trim() !== '' ? 'lightgreen' : '#ffcdd2',
                            marginLeft: '8px',
                            fontSize: '1.1em'
                        }}>
                            {getButtonIndicator()}
                        </span>
                    }
                >
                    Add whole text translation
                </Button>
            }

            { isEditing && (
                <Paper 
                    elevation={1} 
                    sx={{ 
                        p: 2, 
                        mt: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 2,
                        overflow: 'hidden'
                    }}
                >
                    <Box 
                        className="translation-creator-resizable"
                        sx={{ 
                            display: 'flex', 
                            gap: 2, 
                            height: 280,
                            minHeight: 120,
                            maxHeight: '70vh',
                            overflow: 'auto'
                        }}
                    >
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Original Text
                            </Typography>
                            <Box 
                                sx={{ 
                                    flex: 1,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    p: 2,
                                    overflow: 'auto',
                                    backgroundColor: 'grey.50',
                                    fontSize: '1.05em',
                                    lineHeight: 1.6
                                }}
                            >
                                {originalText || 'No text available'}
                            </Box>
                        </Box>
                        
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Translation
                            </Typography>
                            <textarea 
                                name="wholeText" 
                                style={{ 
                                    flex: 1,
                                    width: '100%',
                                    minHeight: 80,
                                    fontSize: '1.05em',
                                    lineHeight: 1.6,
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '12px',
                                    resize: 'none',
                                    fontFamily: 'inherit',
                                    boxSizing: 'border-box'
                                }} 
                                onChange={handleTranslationInput} 
                                value={currentTranslation}
                                placeholder="Enter your translation here..."
                            />
                        </Box>
                    </Box>
                    
                    <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                        <Button 
                            variant="contained" 
                            color="primary"
                            startIcon={<CheckCircle />}
                            onClick={() => { 
                                onWholeTextTranslation(currentTranslation); 
                                setIsEditing(false); 
                            }}
                        >
                            Save Translation
                        </Button>
                        <Button 
                            variant="outlined" 
                            startIcon={<Cancel />}
                            onClick={() => setIsEditing(false)}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Paper>
            )}
        </Box>
    );
}

export default TranslationCreator;
